export const snsAccounts = [
  {
    id: "tw",
    platform: "X (트위터)",
    icon: "ri-twitter-x-line",
    handle: "@KArtPEN_official",
    followers: 48200,
    following: 312,
    color: "#E0E4F0",
    posts: [
      {
        id: "tw1",
        text: "✨ 루나&스타즈의 1st EP 'Starlight' 발매 D-35! 첫 번째 티저 이미지를 공개합니다 💫 #루나앤스타즈 #Starlight #KArtPEN",
        time: "2시간 전",
        likes: 1842,
        retweets: 534,
        replies: 89,
        sentiment: "positive",
      },
      {
        id: "tw2",
        text: "🎵 DarkNova의 새 앨범 '블랙홀' 제작 비하인드 공개! MV 촬영 현장을 함께해요 🖤 #DarkNova #블랙홀",
        time: "1일 전",
        likes: 3241,
        retweets: 812,
        replies: 201,
        sentiment: "positive",
      },
      {
        id: "tw3",
        text: "📢 [공지] 루나&스타즈 팬미팅 티켓 선예매 안내. 4월 3일 오전 11시 오픈! 많은 참여 부탁드립니다 💕",
        time: "3일 전",
        likes: 2105,
        retweets: 987,
        replies: 445,
        sentiment: "positive",
      },
    ],
  },
  {
    id: "ig",
    platform: "인스타그램",
    icon: "ri-instagram-line",
    handle: "@kartpen_official",
    followers: 125400,
    following: 198,
    color: "#E8375F",
    posts: [
      {
        id: "ig1",
        text: "루나&스타즈 EP 콘셉트 포토 1차 공개 🌙⭐",
        time: "1시간 전",
        likes: 8423,
        retweets: 0,
        replies: 342,
        imageUrl: "https://public.readdy.ai/ai/img_res/9b9da60180938fdf6ead43015212e094.jpg",
        sentiment: "positive",
      },
      {
        id: "ig2",
        text: "DarkNova MV 촬영장 스틸컷 공개 🖤",
        time: "2일 전",
        likes: 12540,
        retweets: 0,
        replies: 567,
        imageUrl: "https://readdy.ai/api/search-image?query=kpop%20idol%20male%20dark%20concept%20shoot%20moody%20lighting%20dramatic%20black%20background%20neon%20glow%20strong%20aesthetic%20powerful%20intense%20look%20professional%20photography&width=400&height=400&seq=ig2post&orientation=squarish",
        sentiment: "positive",
      },
    ],
  },
];

export const aiComments = [
  { type: "positive", text: "역대급이다 진짜... 미쳤어 😭❤️ 이 컨셉 내 취향 저격", count: 2841 },
  { type: "positive", text: "루나언니 이번 컨셉 너무 이쁘다 내 심장이...", count: 1920 },
  { type: "positive", text: "얼른 음원 내줘요 기다리다 늙겠어요 ㅠㅠ 제발", count: 1432 },
  { type: "negative", text: "이거 콘셉트 어디서 많이 본 것 같은데... 독창성이 좀 아쉽네", count: 234 },
  { type: "negative", text: "마케팅 너무 과하다는 느낌... 음악으로 승부해", count: 178 },
  { type: "positive", text: "DarkNova 이번 비주얼 완전 다른 사람 같아 성장했다", count: 3102 },
  { type: "neutral", text: "티저 나왔는데 음원은 언제 나와요 일정 공개해주세요", count: 987 },
  { type: "positive", text: "팬미팅 꼭 갈거야!!! 티켓팅 각 잡았음", count: 1654 },
];

export const chartData = [
  { rank: 1, prev: 3, title: "Supernova", artist: "에스파", streams: 2840000, change: "up", label: "SM" },
  { rank: 2, prev: 1, title: "Love Wins All", artist: "IU", streams: 2612000, change: "down", label: "EDAM" },
  { rank: 3, prev: 5, title: "Magnetic", artist: "ILLIT", streams: 2489000, change: "up", label: "BELIFT LAB" },
  { rank: 4, prev: 4, title: "홍보 인생", artist: "영탁", streams: 2210000, change: "same", label: "도그후드" },
  { rank: 5, prev: 8, title: "Starlight (루나&스타즈)", artist: "루나&스타즈", streams: 1950000, change: "up", label: "K-ArtPEN", isOurs: true },
  { rank: 6, prev: 6, title: "SPOT!", artist: "지코 ft.제니", streams: 1820000, change: "same", label: "KOZ" },
  { rank: 7, prev: 9, title: "APT.", artist: "ROSE ft.Bruno Mars", streams: 1740000, change: "up", label: "Atlantic" },
  { rank: 8, prev: 7, title: "Slow Dancing", artist: "빅토리아모네", streams: 1600000, change: "down", label: "Def Jam" },
  { rank: 9, prev: 12, title: "블랙홀 (DarkNova)", artist: "DarkNova", streams: 1420000, change: "up", label: "K-ArtPEN", isOurs: true },
  { rank: 10, prev: 10, title: "Crazy", artist: "LE SSERAFIM", streams: 1380000, change: "same", label: "SOURCE" },
];

export const pressReleases = [
  {
    id: "pr1",
    title: "루나&스타즈 1st EP 발매 공식 보도자료",
    status: "배포완료",
    media: ["연합뉴스", "스포츠조선", "아이돌차트", "뮤직뱅크"],
    date: "2026.03.20",
    reach: 124000,
  },
  {
    id: "pr2",
    title: "DarkNova MV 제작 시작 공지",
    status: "배포완료",
    media: ["스타뉴스", "엑스포츠뉴스"],
    date: "2026.03.15",
    reach: 58000,
  },
];
